let appInstance

function setAppInstance(instance) {
    appInstance = instance
}

export {setAppInstance, appInstance}
